// IE 2026 11 03 / ODOO-350449 (заказ Игоря: p231 підказка по сигналу — проблема як у формі комірки)
// Alt-подсказка над сигналом вида «Сигнали» (кружки-сигналы ячеек, utils/cellViews/signals.js) — проблемы ячейки ТЕМ ЖЕ видом, что блок PROBLEMS формы ячейки
// (CellStory.vue part='problem'): бейдж оценки (классы dropdown-story-badge is-critical / is-bad / is-warning — те же стили) и строка-цепочка проблемы
// («Calculated stock ≠ actual», «Deficit → Speed up the next receipt»), по строке на проблему. Строки — utils/cellStory.story_chains (тот же список, что у формы),
// ключи строк — те же, что у CellStory.rows ('critical', 'p<i>', 'p0', 'group'): клик по сигналу открывает форму ячейки и раскрывает строку с этим ключом
// (память формы 'storyRow:<ключ>' — как щелчок по проблеме внутри формы) и прокручивает к ней.
// Данные — story ячейки из ответа cell_passport (params.story = 1): у строки грида проблем нет, грид запрашивает их лениво при Alt-наведении (AttrGrid.signalTip_*),
// до ответа — «…». Выключатель fe.ux.signalTipProblems (дефолт ВКЛ): ВЫКЛ — прежняя подсказка «SIGNALS · Bad grade» и метка «Signal in the cell».
// Тесты — tests/unit/signalTipProblems.test.mjs
import { t as tI18n } from '@/i18n'

export const SIGNAL_TIP_FLAG = 'fe.ux.signalTipProblems'
// метки «Marks» подсказки ячейки, которые повторяют сигнал (подсказка с проблемами их не пишет)
export const SIGNAL_TIP_SKIP_MARKS = ['grid.mark.metricFill']
// сигнал вида → оценки / виды проблем story, которые он означает (выбор строки, к которой открывается форма; не нашлось — первая строка)
const SIGNAL_MATCH = {
    uncovered: { kinds: ['uncovered', 'oos'] },
    bad: { grades: ['critical', 'bad'] },
    expired: { kinds: ['expiry'] },
    excess: { kinds: ['excess'] },
    'over-max': { kinds: ['excess'] },
    warning: { grades: ['warning'] },
}

const str = (v) => (v === null || v === undefined ? '' : String(v)).trim()
const esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')

// выключатель: читатель настроек (key, default) → значение; нет читателя / ошибка — ВКЛ
export function signalTip_on(setting) {
    if (typeof setting !== 'function') return true
    try { return setting(SIGNAL_TIP_FLAG, true) !== false } catch (e) { return true }
}

// строки story_chains (mode '') → строки подсказки: { key, kind, grade, gradeText, gradeCss, label, links: [подписи звеньев причина / решение / деньги], accepted, horizon, problemKind }
// key — ключ строки формы (CellStory.rows): критический вердикт 'critical', обычная цепочка 'p0', проблема списка — её r.key ('p<i>'), группа — 'group'
export function signalTip_rows(chains) {
    const out = []
    for (const r of (Array.isArray(chains) ? chains : [])) {
        if (!r || typeof r !== 'object') continue
        if (r.kind === 'critical' && r.critical) {
            const c = r.critical
            const money = c.money ? str(c.money.label || c.money.text) : ''
            out.push({ key: 'critical', kind: 'critical', grade: 'critical', gradeText: str(c.gradeText), gradeCss: str(c.gradeCss) || 'is-critical', label: str(c.label || c.title),
                links: money ? [money] : [], accepted: false, horizon: '', problemKind: 'stock_mismatch' })
        } else if ((r.kind === 'chain' || r.kind === 'problem') && r.chain && r.chain.problem) {
            const ch = r.chain, p = ch.problem
            const links = [ch.cause && ch.cause.label, ch.solution && ch.solution.label, ch.money && ch.money.label].map(str).filter(Boolean)
            out.push({ key: r.kind === 'chain' ? 'p0' : str(r.key), kind: 'problem', grade: str(p.grade), gradeText: str(p.gradeText), gradeCss: str(p.gradeCss), label: str(p.label || p.title),
                links, accepted: !!ch.accepted, horizon: str(p.horizon), problemKind: str((r.problem && r.problem.kind) || (ch.story && ch.story.problem && ch.story.problem.kind)) })
        } else if (r.kind === 'group' && r.group) {
            const g = r.group
            out.push({ key: 'group', kind: 'group', grade: '', gradeText: str(g.with_problems), gradeCss: 'is-count', label: str(g.worst ? g.worst.title : g.text), links: [], accepted: false, horizon: '', problemKind: '' })
        }
    }
    return out
}

// строка, к которой открывается форма по клику на сигнал: первая строка, подходящая сигналу (внешнее кольцо — первый в signalKinds), иначе первая строка; нет строк — null
export function signalTip_pick(rows, signalKinds) {
    const list = Array.isArray(rows) ? rows.filter(Boolean) : []
    if (!list.length) return null
    for (const k of (Array.isArray(signalKinds) ? signalKinds : [])) {
        const m = SIGNAL_MATCH[k]
        if (!m) continue
        const hit = list.find(r => (m.grades && m.grades.includes(r.grade)) || (m.kinds && m.kinds.includes(r.problemKind)))
        if (hit) return hit
    }
    return list[0]
}

// память формы для раскрытия строки (как щелчок по проблеме внутри формы): критическая / группа — 'open', проблема — карточка «проблема» (её расшифровка)
export function signalTip_focusOf(row) {
    if (!row || !row.key) return null
    return { key: row.key, mem: 'storyRow:' + row.key, value: row.kind === 'problem' ? 'problem' : 'open' }
}

// html строк проблем — разметка строки PROBLEMS формы (бейдж оценки + заголовок + звенья через «→»), классы стилей CellStory.vue (нескоупленный блок)
export function signalTip_rowsHtml(rows, t = tI18n) {
    const tt = typeof t === 'function' ? t : (x) => x
    return (Array.isArray(rows) ? rows : []).map(r => {
        const badge = (r.accepted ? `<span class="dropdown-story-badge is-accepted">${esc(tt('Accepted'))}</span>` : '')
            + (r.gradeText ? `<span class="dropdown-story-badge ${esc(r.gradeCss)}">${esc(r.gradeText)}</span>` : '')
        const horizon = r.horizon ? `<span class="dropdown-story-badge is-horizon">${esc(r.horizon)}</span>` : ''
        const links = (r.links || []).map(l => `<span class="dropdown-story-arrow">→</span><span class="dropdown-story-seg-title">${esc(l)}</span>`).join('')
        return `<div class="dropdown-story-chain-row sig-tip-prow" data-problem="${esc(r.key)}">${badge}<span class="dropdown-story-seg-title">${esc(r.label)}</span>${horizon}${links}</div>`
    }).join('')
}

// подсказка над сигналом: заголовок ячейки и значение (как у подсказки вида), раздел PROBLEMS со строками либо «…» до ответа, строка про клик.
// opts: { t, head, valueText, rows, state: 'loading' | 'ok' } → html; state 'ok' без строк — '' (вызывающий показывает прежнюю подсказку вида)
export function signalTip_html(opts = {}) {
    const t = typeof opts.t === 'function' ? opts.t : tI18n
    const loading = opts.state === 'loading'
    const rows = Array.isArray(opts.rows) ? opts.rows : []
    if (!loading && !rows.length) return ''
    const head = str(opts.head), val = str(opts.valueText)
    const body = loading ? `<div class="hm-tip-sub sig-tip-loading">…</div>` : signalTip_rowsHtml(rows, t)
    return `<div class="hm-tip hm-tip-g cell-pie-tip cell-ring-tip sig-tip">`
        + `<div class="hm-tip-head">${head ? `<div class="hm-tip-title">${esc(head)}</div>` : ''}${val ? `<div class="hm-tip-sub">${esc(t('Cell value'))}: ${esc(val)}</div>` : ''}</div>`
        + `<div class="hm-tip-sec sig-tip-sec"><div class="hm-tip-cap">${esc(t('PROBLEMS'))}</div>${body}</div>`
        + (loading ? '' : `<div class="hm-tip-sub sig-tip-click">${esc(t('Click the signal — the cell form opens on this problem'))}</div>`)
        + `</div>`
}
